import { type Point } from '../../../../Commons/Geometry';

export abstract class HeatmapBaseRenderer {
    public abstract draw (gr: CanvasRenderingContext2D, mousePoint: Point): void;
}
